import React, { Fragment } from "react";
import "./loginErrorPage.scss";

import useRedirectUrl from "../../hooks/rpDetails";
import { CoreButton } from "@komodo-design-system/komodo-components-react";
import { logAuditData } from "../../utils/auditLogger";
import { getCountry } from '../../services/localeSupport.service';

const site = window.location.host.includes('thermofisher.cn') ? 'China' : 'US';

function LoginErrorPage() {
  // const [t] = useTranslation("global");
  window.tfIdentityGlobals?.hideLoader();
  const rpdetailsUrl = useRedirectUrl();

  React.useEffect(() => {
    if ([
      'bm', 'bo', 'bz', 'cu', 'ly', 'mc', 'mo', 'pg', 'li', 'bb', 'sy', 'bs', 'fj', 'gi', 'ir', 'kp'
    ].includes(getCountry())) {
      const responseData = {
        errorCode: "Embargo Country",
        errorMessage: "Url accessed from embargoed country"
      };
      logAuditData("Blocked Country", "URL Access Denied", responseData, site);
    }
  }, []);

  const goToHomePage = () => {
    window.location.href = rpdetailsUrl?.logoLink;
  };

  return (
    <Fragment>
      <div className="outer-Div-loginErrorpage">
        <div className="loginErrorpage-body">
          <div className="buttonCompDiv">
            <h1>Our login system is currently having technical difficulties</h1>
            <p>
              Please wait a moment and try again. In the meantime, feel free to
              browse the site.
            </p>
            <CoreButton
              type="button"
              variant="primary"
              size="medium"
              onClick={goToHomePage}
            >
              <span slot="content">
                Go to homepage
              </span>
            </CoreButton>
          </div>
          <div className="contact-us">
            <strong className="need-assis">Need assistance? </strong>
            <a
              href={rpdetailsUrl?.contactUsLink}
              style={{ textDecoration: "underline", color: "#1E8AE7", cursor:"pointer" }}
              className="need-assis"
            >
              Contact us
            </a>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default LoginErrorPage;
